<template>
  <v-col cols="12">
    <v-card elevation="0" color="grey lighten-5">
      <v-col cols="12">
        <h1>{{ $t("stations.title") }}</h1>
      </v-col>
      <v-col cols="12">
        <p v-html="$t('stations.text')"></p>
      </v-col>
    </v-card>
    <v-card elevation="0" color="grey lighten-5">
      <v-col cols="12">
        <h3>{{ $t("stations.subtitle") }}</h3>
      </v-col>

      <v-col cols="12">
        <v-autocomplete
          dense
          v-model="model"
          :items="items"
          :loading="isLoading"
          filled
          :search-input.sync="search"
          hide-no-data
          @change="selectCity"
          hide-selected
          item-text="search_nom"
          :placeholder="$t('stations.form.map.searchLabel')"
          return-object
          no-filter
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" v-if="model || station.latitude || station.longitude">
        <v-form ref="stationForm" v-model="stationValid" lazy-validation>
          <v-row>
            <v-col cols="12">
              <v-text-field
                filled
                dense
                v-model="station.libelle_station"
                :rules="[(v) => !!v || $t('stations.form.label.error')]"
                :label="$t('stations.form.label.title')"
                required
              ></v-text-field>
            </v-col>
            <v-col :cols="$vuetify.breakpoint.mobile ? '12' : '6'">
              <v-text-field
                filled
                dense
                @input="resetModel"
                disabled
                v-model="station.longitude"
                :rules="[(v) => !!v || $t('stations.form.longitude.error')]"
                :label="$t('stations.form.longitude.title')"
                required
              ></v-text-field>
              <v-text-field
                filled
                dense
                disabled
                @input="resetModel"
                v-model="station.latitude"
                :rules="[(v) => !!v || $t('stations.form.latitude.error')]"
                :label="$t('stations.form.latitude.title')"
                required
              ></v-text-field>
              <v-text-field
                filled
                dense
                v-model="station.altitude"
                :rules="[(v) => !!v || $t('stations.form.altitude.error')]"
                :label="$t('stations.form.altitude.title')"
                required
              ></v-text-field>
              <v-select
                filled
                dense
                v-model="station.code_pays"
                :items="countriesList"
                item-text="name"
                item-value="iso2"
                :rules="[(v) => !!v || $t('stations.form.country.error')]"
                :label="$t('stations.form.country.title')"
                required
              ></v-select>
              <v-select
                dense
                filled
                v-model="station.id_timezone"
                :items="timezonesList"
                item-text="libelle_gmt"
                item-value="id_timezone"
                :rules="[(v) => !!v || $t('stations.form.timezone.error')]"
                :label="$t('stations.form.timezone.title')"
                required
              ></v-select>
              <v-text-field
                filled
                dense
                v-model="station.correction_pression"
                :label="$t('stations.form.pressure.title')"
              ></v-text-field>
              <v-text-field
                filled
                dense
                v-model="station.url_webcam"
                :label="$t('stations.form.webcam.title')"
              ></v-text-field>
              <v-text-field
                filled
                dense
                v-model="station.url_site_web"
                :label="$t('stations.form.website.title')"
              ></v-text-field>
              {{station.id_mode_transfert}}
              <v-select
                filled
                dense
                v-model="station.id_mode_transfert"
                :items="modeTransfertList"
                item-text="mode_transfert"
                item-value="id_mode_transfert"
                :rules="[v => !!v || $t('stations.form.transfert.error')]"
                :label="$t('stations.form.transfert.title')"
                required
              ></v-select>
              <template v-if="station.id_mode_transfert === 2">
                <v-select
                  filled
                  dense
                  v-model="station.unite_temp"
                  :items="['°C', '°F']"
                  :label="$t('stations.form.transfert.mode2.temperature')"
                ></v-select>
                <v-select
                  filled
                  dense
                  v-model="station.unite_pression"
                  :items="['hPa', 'inHg', 'mmHg']"
                  :label="$t('stations.form.transfert.mode2.pressure')"
                ></v-select>
                <v-select
                  filled
                  dense
                  v-model="station.unite_precipitation"
                  :items="['mm', 'inch']"
                  :label="$t('stations.form.transfert.mode2.precipitation')"
                ></v-select>
                <v-select
                  filled
                  dense
                  v-model="station.unite_vent"
                  :items="['km/h', 'mph', 'm/s', 'noeuds']"
                  :label="$t('stations.form.transfert.mode2.wind')"
                ></v-select>
              </template>
              <template v-else-if="station.id_mode_transfert === 3">
                <v-text-field
                  filled
                  dense
                  v-model="modeTransfert3.url_fichier_txt"
                  :label="$t('stations.form.transfert.mode3.fileUrl')"
                ></v-text-field>
              </template>
              <template v-else-if="station.id_mode_transfert === 9">
                <v-text-field
                  filled
                  dense
                  v-model="modeTransfert9.url_fichier_txt"
                  :label="$t('stations.form.transfert.mode9.fileUrl')"
                ></v-text-field>
              </template>
            </v-col>
            <v-col :cols="$vuetify.breakpoint.mobile ? '12' : '6'">
              <l-map
                ref="map"
                v-if="showMap"
                :zoom="zoom"
                :center="center"
                :options="mapOptions"
                style="height: 70vh; z-index: 1"
                @click="addMarker"
                @update:center="centerUpdate"
                @update:zoom="zoomUpdate"
              >
                <l-marker
                  v-if="
                    markerLatLon.length && +markerLatLon[0] && +markerLatLon[1]
                  "
                  :lat-lng="markerLatLon"
                ></l-marker>
                <l-tile-layer :url="url" />
                <l-control position="topright"> </l-control>
              </l-map>
            </v-col>
          </v-row>
          <v-col class="text-right" cols="12">
            <v-btn elevation="0" :disabled="loading" color="success" @click="createStation">{{
              $t("stations.form.submitBtn")
            }}</v-btn>
          </v-col>
        </v-form>
      </v-col>
    </v-card>
    <v-snackbar v-model="success" color="success" top>{{
      $t("stations.snackbarSuccess")
    }}</v-snackbar>
    <v-snackbar v-model="error" color="error" top>{{
      $t("stations.snackbarError")
    }}</v-snackbar>
  </v-col>
</template>

<script>
// Leaflet
import { LMap, LTileLayer, LControl, LMarker } from "vue2-leaflet";

// Store
import { mapState } from "vuex";

// API
import api from "../../api";

export default {
  name: "Create",

  components: {
    LMap,
    LTileLayer,
    LControl,
    LMarker,
  },

  computed: {
    ...mapState(["user"]),
    items() {
      return this.entries.map((chunk) =>
        chunk.cp
          ? {
              ...chunk,
              search_nom: `${chunk.nom} (${chunk.cp.slice(0, 2)}) ${chunk.iso}`,
            }
          : { ...chunk, search_nom: `${chunk.nom} ${chunk.iso}` }
      );
    },
    markerLatLon() {
      if (this.station.latitude && this.station.longitude) {
        return [
          parseFloat(this.station.latitude),
          parseFloat(this.station.longitude),
        ];
      }

      return [];
    },
  },

  data() {
    return {
      /********** FULL STATION OBJECT **********/
      // station: {
      //     "id_user": "",
      //     "libelle_station": "",
      //     "code_pays": "",
      //     "longitude": "",
      //     "latitude": "",
      //     "altitude": "",
      //     "correction_pression": "",
      //     "id_mode_transfert": "",
      //     "url_fichier_txt": "",
      //     "url_webcam": "",
      //     "id_timezone": "",
      //     "unite_temp": "",
      //     "unite_pression": "",
      //     "unite_precipitation": "",
      //     "unite_vent": "",
      //     "format_date": "",
      //     "date_insert": "",
      //     "valide": "",
      //     "monitoring": "",
      //     "url_site_web": "",
      //     "sodaq":""
      // }
      station: {
        libelle_station: "",
        longitude: "",
        latitude: "",
        altitude: "",
        code_pays: "",
        id_timezone: 155,
        correction_pression: "",
        id_mode_transfert: null,
        url_webcam: "",
        url_site_web: "",
        unite_temp: "°C",
        unite_pression: "hPa",
        unite_precipitation: "mm",
        unite_vent: "km/h",
      },
      modeTransfert3: {
        url_fichier_txt: "",
      },
      modeTransfert9: {
        url_fichier_txt: "",
      },
      /********** END STATION OBJECT **********/
      countriesList: [],
      timezonesList: [],
      modeTransfertList: [],
      stationValid: true,
      // Snackbar
      success: false,
      error: false,
      // Leafet
      showMap: true,
      zoom: 5,
      center: [47, 2],
      mapOptions: {
        zoomSnap: 0.5,
      },
      model: null,
      url: "https://tile.openstreetmap.org/{z}/{x}/{y}.png",
      // Autocomplete
      entries: [],
      search: null,
      // General
      isLoading: false,
      loading:false,
    };
  },

  methods: {
    getCurrenPosition()
    {
      navigator.geolocation.getCurrentPosition((position)=> {
        console.log(position);
        this.model = true;
        this.station.latitude = position.coords.latitude;
        this.station.longitude = position.coords.longitude;
      }); 
    },
    // API get all countries
    async getCountries() {
      try {
        let res = await api.stations.getCountries();

        this.countriesList = res;
      } catch (err) {
        console.error(err.message);
      }
    },
    // API get all timezones
    async getTimezones() {
      try {
        let res = await api.stations.getTimezones();

        this.timezonesList = res;
      } catch (err) {
        console.error(err.message);
      }
    },
    // API get all transfert methods
    async getConnectors() {
      try {
        let res = await api.stations.getConnectors();

        this.modeTransfertList = res;
      } catch (err) {
        console.error(err.message);
      }
    },
    resetModel() {
      this.model = null;
    },
    // @submit on new station form
    async createStation() {
      let modeTransfert = null;

      await this.$refs.stationForm.validate();
      if(!this.stationValid) return;

      try {
        switch (this.station.id_mode_transfert) {
          case 3:
            modeTransfert = this.modeTransfert3;
            break;
          case 9:
            modeTransfert = this.modeTransfert9;
            break;
        }

        let station = { ...this.station, ...modeTransfert };

        await api.stations.createStation(this.user.id_user, station);

        this.success = true;
      } catch (err) {
        this.error = true;
        console.error(err.message);
      }
    },
    /********** LEAFLET METHODS **********/
    async selectCity(e) {
      let LatLon = [parseFloat(e.lat), parseFloat(e.lon)];
      try{
        let infos = await api.cities.getinfos(e.geoname);
        this.station.altitude = infos.elevation;
        let timezone = this.timezonesList.find(map=>map.libelle_gmt == infos.fuseau);
        this.stations.id_timezone = timezone.id_timezone;
      }catch(err)
      {
        console.log(err);
      }
      // Clear form input
      this.geoname = e.geoname;
      this.conditions = [];

      // Station Lat Lon
      this.station.latitude = parseFloat(e.lat);
      this.station.longitude = parseFloat(e.lon);

      this.$refs.map.mapObject.setView(LatLon, 12);
    },
    addMarker(e) {
      // Clear form input
      this.conditions = [];

      this.station.latitude = this.station.latitude.toFixed(3);
      this.station.longitude = this.station.longitude.toFixed(3);

      // Station Lat Lon
      this.station.latitude = parseFloat(e.latlng.lat);
      this.station.longitude = parseFloat(e.latlng.lng);
    },
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },
  },

  watch: {
    search(val) {

      this.isLoading = true;

      // Lazily load input items
      api.cities
        .search(val)
        .then((res) => {
          this.entries = res;
          this.count = res.length;
        })
        .catch((err) => {
          console.err(err.message);
        })
        .finally(() => (this.isLoading = false));
    },
    // Move view on click
    markerLatLon() {
      if (
        this.markerLatLon.length &&
        +this.markerLatLon[0] &&
        +this.markerLatLon[1]
      )
        this.$refs.map.mapObject.setView(
          [this.markerLatLon[0], this.markerLatLon[1]],
          12
        );
    },
  },

  mounted() {
    this.getCurrenPosition();
    this.getCountries();
    this.getTimezones();
    this.getConnectors();
  },
};
</script>

<style>
* {
  word-break: break-word;
}

.leaflet-control {
  width: 100%;
  margin: 0px !important;
}

.leaflet-top.leaflet-right {
  width: 100%;
  margin: 0px !important;
}
</style>